var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBaseball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4756,
    cy: 13.4756,
    r: 10,
    transform: "rotate(-27.3385 13.4756 13.4756)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11199_1818",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 21,
    height: 21
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4756,
    cy: 13.4756,
    r: 10,
    transform: "rotate(-27.3385 13.4756 13.4756)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11199_1818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7588 18.7762C14.2387 21.113 8.67698 19.3385 6.33736 14.8131C4.96638 12.1612 5.00904 9.15572 6.18398 6.65001C3.38183 9.68162 2.6249 14.2621 4.63155 18.1436C7.19316 23.0984 13.28 25.0404 18.2289 22.4819C22.1081 20.4764 24.1334 16.3005 23.5939 12.2048C23.1068 14.9299 21.405 17.4081 18.7588 18.7762Z",
    fill: "#C9CACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.409 15.377L16.2834 14.4719L16.1377 15.1099L17.1268 15.9063L16.9915 16.4987L18.5565 16.3482L18.7022 15.7102L17.3039 15.8426L17.409 15.377Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0579 13.5143L17.1318 12.404L16.8653 12.9994L17.6753 13.9749L17.4241 14.5283L18.9886 14.6934L19.26 14.0955L17.8603 13.9504L18.0579 13.5143Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.06 11.8152L18.3747 10.5433L17.9919 11.0751L18.5941 12.1921L18.2402 12.6842L19.7402 13.1547L20.123 12.6229L18.782 12.2032L19.06 11.8152Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3796 10.3481L19.9578 8.9647L19.4781 9.41058L19.8497 10.6252L19.4051 11.0374L20.7828 11.7968L21.2625 11.3509L20.0295 10.6744L20.3796 10.3481Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9609 9.172L21.8217 7.73213L21.2645 8.07586L21.3864 9.33912L20.8706 9.6553L22.0714 10.67L22.6299 10.3287L21.5557 9.42166L21.9609 9.172Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1418 17.3331L15.8612 16.6658L15.8421 17.3218L16.9695 17.9076L16.9559 18.5144L18.4589 18.0589L18.4755 17.4041L17.1301 17.8122L17.1418 17.3331Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2676 19.3028L15.879 18.9046L15.9923 19.5478L17.2121 19.9003L17.315 20.4995L18.6998 19.7557L18.589 19.1112L17.3515 19.7757L17.2676 19.3028Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7789 21.2114L16.3403 21.0926L16.5758 21.7036L17.8425 21.8062L18.0614 22.3731L19.2721 21.37L19.0341 20.7604L17.9533 21.6562L17.7789 21.2114Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90769 10.2154L8.34146 10.3635L8.19576 11.0015L9.59409 10.8691L9.48892 11.3347L10.6159 12.2422L10.7591 11.6055L9.7724 10.8078L9.90769 10.2154Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90818 12.0219L7.64162 12.6173L9.03894 12.7637L8.84132 13.1997L9.76495 14.3113L10.0339 13.7147L9.22389 12.7391L9.47139 12.1845L7.90818 12.0219Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15531 13.558L6.77495 14.0886L8.11722 14.5107L7.83917 14.8987L8.52451 16.1706L8.90732 15.6388L8.30269 14.523L8.65777 14.0272L7.15531 13.558Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11653 14.9177L5.63681 15.3635L6.86974 16.0401L6.51966 16.3664L6.94024 17.7473L7.41996 17.3015L7.04959 16.0893L7.49293 15.6746L6.11653 14.9177Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91912 15.9943L4.36189 16.3381L5.43605 17.2451L5.02963 17.4923L5.1688 18.9322L5.72729 18.5909L5.60532 17.3276L6.12122 17.0114L4.91912 15.9943Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0368 10.046L11.0534 9.39124L9.92971 8.80661L9.94332 8.19979L8.43904 8.65286L8.42242 9.30762L9.76907 8.90203L9.7561 9.37866L11.0368 10.046Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66304 7.55006L11.0529 7.95072L10.9407 7.30379L9.7222 6.95371L9.61689 6.35581L8.23202 7.0996L8.34288 7.74409L9.58282 7.07832L9.66304 7.55006Z",
    fill: "#CE152D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23247 5.71956L10.6711 5.83837L10.4331 5.22869L9.16894 5.1248L8.94994 4.55786L7.73927 5.56095L7.97726 6.17063L9.05813 5.27484L9.23247 5.71956Z",
    fill: "#CE152D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBaseball);
export default __webpack_public_path__ + "static/media/icon_baseball.c65f638399a20295b39ffe85d65327d5.svg";
export { ForwardRef as ReactComponent };